export default function () {
  // setando valores para schedules
  this.setSchedules()
}



// WEBPACK FOOTER //
// ./src/app/professional/schedulings/preview/resources/mounted.js